// extracted by mini-css-extract-plugin
export var addNoScroll = "ImageGallery-module--add-no-scroll--3MhTY";
export var bxTextTruncateEnd = "ImageGallery-module--bx--text-truncate--end--14ZUf";
export var bxTextTruncateFront = "ImageGallery-module--bx--text-truncate--front--2DrfU";
export var closeButton = "ImageGallery-module--close-button--3bHhg";
export var column = "ImageGallery-module--column--3jXZx";
export var figure = "ImageGallery-module--figure--1dKOy";
export var firstRightNav = "ImageGallery-module--first-right-nav--1A3y9";
export var galleryContainer = "ImageGallery-module--gallery-container--18JDB";
export var galleryGrid = "ImageGallery-module--gallery-grid--2RC4C";
export var galleryRow = "ImageGallery-module--gallery-row--1IlYd";
export var icon = "ImageGallery-module--icon--3YW61";
export var imageButtonWrapper = "ImageGallery-module--image-button-wrapper---v8Vt";
export var imageInDialog = "ImageGallery-module--image-in-dialog--2pbFw";
export var imageTitle = "ImageGallery-module--image-title--2JxX_";
export var inDialogGalleryContainer = "ImageGallery-module--in-dialog-gallery-container--2fE_y";
export var leftNav = "ImageGallery-module--left-nav--1zMEq";
export var navButtons = "ImageGallery-module--nav-buttons--3zImO";
export var navButtonsContainer = "ImageGallery-module--nav-buttons-container--1zfnl";
export var rightNav = "ImageGallery-module--right-nav--1VPx2";